import { ref } from 'vue';

// Almacenamiento para el temporizador, para evitar múltiples temporizadores si se llama showToast rápidamente
let timeoutId = null;

/**
 * Composable para gestionar mensajes de notificación (toast).
 * Proporciona una referencia reactiva para el mensaje actual y una función para mostrar nuevos mensajes.
 */
export function useNotifications() {
  // Usamos una referencia estática compartida si queremos que todos los usos compartan el mismo estado de toast.
  // Si cada componente debe tener su propio toast, simplemente define toastMessage aquí dentro.
  // Por ahora, asumimos un toast global/compartido.
  const toastMessage = ref('');

  /**
   * Muestra un mensaje de notificación durante un tiempo determinado.
   * @param {string} message - El mensaje a mostrar.
   * @param {number} [duration=3000] - La duración en milisegundos que el mensaje estará visible.
   */
  function showToast(message, duration = 3000) {
    toastMessage.value = message;

    // Limpiar el temporizador anterior si existe
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // Establecer un nuevo temporizador para borrar el mensaje
    timeoutId = setTimeout(() => {
      toastMessage.value = '';
      timeoutId = null; // Limpiar la referencia al temporizador
    }, duration);
  }

  // Devolver la referencia reactiva y la función para mostrar el toast
  return {
    toastMessage,
    showToast,
  };
} 